import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language } from '@shared/constants/language';
import MobileUtils from '@shared/utils/mobile.utils';

@Component({
  selector: 'app-app-download-banner',
  templateUrl: './app-download-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    .download-btn {
      cursor: pointer;

      img {
        width: 100%;
        max-width: 200px;
        min-width: 180px;
        height: auto;
      }
    }
  `,
})
export class AppDownloadBannerComponent {
  private translateService = inject(TranslateService);

  isMobile = signal<boolean>(false);
  currentLang = signal<Language>(this.translateService.getCurrentLang() as Language);
  isIOS = signal<boolean>(false);
  isAndroid = signal<boolean>(false);

  readonly Language = Language;

  private iosUrl = 'https://apps.apple.com/app/id6755549681';
  private androidUrl = 'https://play.google.com/store/apps/details?id=com.devinco.skiapp';

  ngOnInit(): void {
    this.isAndroid.set(MobileUtils.isAndroid());
    this.isIOS.set(MobileUtils.isIOS());
    this.isMobile.set(MobileUtils.isMobile());
  }

  downloadApp(): void {
    if (this.isIOS()) {
      window.location.href = this.iosUrl;
    } else if (this.isAndroid()) {
      window.location.href = this.androidUrl;
    }
  }
}
